import axios from "axios";

export const getInvitationData = (hash) =>
  axios.get(`/api/v2/refer-a-friend/${hash}`);
